import React from "react";

const JumboAppContext = React.createContext({});

export default JumboAppContext;
